"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let cache = new Map();
function get(property, value) {
    return cache.get(property + value);
}
exports.get = get;
function set(property, value, className) {
    if (process.env.NODE_ENV !== 'production') {
        const valueType = typeof value;
        if (valueType !== 'boolean' &&
            valueType !== 'number' &&
            valueType !== 'string') {
            const encodedValue = JSON.stringify(value);
            throw new TypeError(`📦 ui-box: invalid cache value “${encodedValue}”. Only booleans, numbers and strings are supported.`);
        }
    }
    cache.set(property + value, className);
}
exports.set = set;
function entries() {
    return [...cache];
}
exports.entries = entries;
function hydrate(newEntries) {
    cache = new Map([...cache, ...newEntries]);
}
exports.hydrate = hydrate;
function clear() {
    cache.clear();
}
exports.clear = clear;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FjaGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY2FjaGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFHQSxJQUFJLEtBQUssR0FBRyxJQUFJLEdBQUcsRUFBa0IsQ0FBQTtBQUVyQyxTQUFnQixHQUFHLENBQUMsUUFBZ0IsRUFBRSxLQUFpQjtJQUNyRCxPQUFPLEtBQUssQ0FBQyxHQUFHLENBQUMsUUFBUSxHQUFHLEtBQUssQ0FBQyxDQUFBO0FBQ3BDLENBQUM7QUFGRCxrQkFFQztBQUVELFNBQWdCLEdBQUcsQ0FBQyxRQUFnQixFQUFFLEtBQTBCLEVBQUUsU0FBaUI7SUFDakYsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxZQUFZLEVBQUU7UUFDekMsTUFBTSxTQUFTLEdBQUcsT0FBTyxLQUFLLENBQUE7UUFDOUIsSUFDRSxTQUFTLEtBQUssU0FBUztZQUN2QixTQUFTLEtBQUssUUFBUTtZQUN0QixTQUFTLEtBQUssUUFBUSxFQUN0QjtZQUNBLE1BQU0sWUFBWSxHQUFHLElBQUksQ0FBQyxTQUFTLENBQUMsS0FBSyxDQUFDLENBQUE7WUFDMUMsTUFBTSxJQUFJLFNBQVMsQ0FDakIsbUNBQW1DLFlBQVksc0RBQXNELENBQ3RHLENBQUE7U0FDRjtLQUNGO0lBRUQsS0FBSyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEdBQUcsS0FBSyxFQUFFLFNBQVMsQ0FBQyxDQUFBO0FBQ3hDLENBQUM7QUFoQkQsa0JBZ0JDO0FBRUQsU0FBZ0IsT0FBTztJQUNyQixPQUFPLENBQUMsR0FBRyxLQUFLLENBQUMsQ0FBQTtBQUNuQixDQUFDO0FBRkQsMEJBRUM7QUFHRCxTQUFnQixPQUFPLENBQUMsVUFBd0I7SUFDOUMsS0FBSyxHQUFHLElBQUksR0FBRyxDQUFpQixDQUFDLEdBQUcsS0FBSyxFQUFFLEdBQUcsVUFBVSxDQUFDLENBQUMsQ0FBQTtBQUM1RCxDQUFDO0FBRkQsMEJBRUM7QUFFRCxTQUFnQixLQUFLO0lBQ25CLEtBQUssQ0FBQyxLQUFLLEVBQUUsQ0FBQTtBQUNmLENBQUM7QUFGRCxzQkFFQyJ9